import { API_BASE_URL } from './api';
import type { WritingGrading } from './api';

export type WorkbookOption = { text: string; pinyin: string; image: string | null; image_missing: boolean };
export type WorkbookQuestion = {
  id: string; level: number; chapter: number; number: number;
  section: 'listening' | 'reading' | 'writing'; mode: 'choice' | 'hanzi' | 'sentence';
  question: string; pinyin: string; options: WorkbookOption[];
  question_image: string | null; question_image_missing: boolean;
  audio: string | null; audio_missing: boolean; audio_review_status?: string; group: string | null;
  review_status: 'pending' | 'verified'; gradable: boolean; transcript?: string; explanation?: string; group_instruction?: string;
  ai_writing?: boolean; writing_scope?: 'keyword_sentence';
};
export type WorkbookAnswers = Record<string, number | string | null>;
export type WorkbookResult = {
  total: number; graded_count: number; pending_count: number; correct_count: number | null;
  percentage: number | null; answered_count: number;
  score?: number; max_score?: number; writing_count?: number; objective_graded_count?: number; objective_correct_count?: number;
  items: { id: string; answer: number | string | null; correct: boolean | null; pending: boolean; expected: number | string[] | null; ai_grading?: WritingGrading & {language?: string; scope?: string}; awarded_score?: number; max_score?: number }[];
};
export type WorkbookAttempt = {
  id: string; level: number; chapter: number; status: 'in_progress' | 'completed'; revision: number;
  current_index: number; answers: WorkbookAnswers; questions: WorkbookQuestion[];
  result: WorkbookResult | null; created_at: string; completed_at: string | null;
};
export async function workbookRequest<T>(path: string, token: string, method = 'GET', body?: unknown): Promise<T> {
  const response = await fetch(`${API_BASE_URL}/workbook${path}`, {
    method, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }), cache: 'no-store',
  });
  const result = await response.json();
  if (!response.ok) throw Object.assign(new Error(result.message || '请求失败，请重试。'),{saved_attempt:result.saved_attempt});
  return result;
}
